module.exports = __webpack_public_path__ + "img/map.0a2a09c0.svg";